import { Container } from '@mui/material';
import HasFeature from 'components/features/HasFeature';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Routes } from 'routing';

import CreateCarrier from './CreateCarrier';
import CreateDelivery from './CreateDelivery';
import EditCarrier from './EditCarrier';
import EditDelivery from './EditDelivery';
import DeliveryHome from './Home';
import DeliveryServicePromoPage from 'components/features/promos/DeliveryServicePromoPage';

const DeliveryRouter = () => {
	return (
		<HasFeature
			requiredFeature="DELIVERY_SERVICE"
			fallback={(failedChecks) => {
				if (failedChecks.user) return <Redirect to={Routes.HOME_VIEW} />;
				return (
					<Container>
						<DeliveryServicePromoPage />
					</Container>
				);
			}}
		>
			<Switch>
				<Route exact path={Routes.DELIVERY} component={DeliveryHome} />
				<Route exact path={Routes.NEW_DELIVERY} component={CreateDelivery} />
				<Route exact path={Routes.NEW_CARRIER} component={CreateCarrier} />
				<Route exact path={Routes.SINGLE_CARRIER} component={EditCarrier} />
				<Route exact path={Routes.SINGLE_DELIVERY} component={EditDelivery} />
				<Redirect to={Routes.DELIVERY} />
			</Switch>
		</HasFeature>
	);
};

export default DeliveryRouter;
